const url = new URL(document.currentScript.src);
const widgetLink = url.href.substring(0, url.href.lastIndexOf("/") + 1);
__webpack_public_path__ = widgetLink;